import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionSyncService } from './core/services/session/session-sync.service';
import { NotifyHostComponent } from './core/components/notify-host/notify-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NotifyHostComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
  constructor(private sessionSync: SessionSyncService) {}

  ngOnInit(): void {
    this.sessionSync.init();
  }
}
